export default __webpack_public_path__ + "assets/img/ict-upload.8da32009af62ce738b070b4e38704ba9.svg";